import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import { withNamespaces } from "react-i18next";

const styles = (theme) => ({
  descriptionContainer: {
    width: "100%",
    border: "2px solid " + theme?.colors?.infoCard?.borderColor,
    padding: "20px 8px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 16px 6px " + theme?.colors?.infoCard?.boxShadow,

    background: theme?.colors?.infoCard?.backgroundGradient,
  },
  title: {
    fontWeight: "700",
    fontSize: "1.3rem",
    color: "#fff",
    margin: "0",
    textAlign: "center",
  },
  description: {
    fontSize: "1.1rem",
    color: "#fff",
    fontWeight: "600",
    textAlign: "center",

    margin: "4px 0 0 0",
  },
});

const infoCard = ({ classes, title, description }) => {
  return (
    <div className={classes.descriptionContainer}>
      <p className={classes.title}>{title}</p>
      {description && <p className={classes.description}>{description}</p>}
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(infoCard)));
